<template>
  <div class="app-shell">
    <SiteHeader
      v-if="!isLegalPage"
      :navigation="content.navigation"
      :actions="content.headerActions"
      :language="content.language"
      :languages="content.languages"
      :resources="content.resources"
      :theme="theme.currentTheme"
      :themes="theme.themes"
      @language-change="setLanguage"
      @theme-change="setTheme"
    />
    <LegalPage v-if="normalizedPath === '/imprint'" :page="content.legalPages.imprint" />
    <LegalPage v-else-if="normalizedPath === '/privacy'" :page="content.legalPages.privacy" />
    <PremiumPage v-else-if="normalizedPath === '/premium'" :premium="content.premium" />
    <BetaTesterPage v-else-if="normalizedPath === '/beta'" :beta="content.betaPage" />
    <SupportProjectPage
      v-else-if="normalizedPath === '/unterstuetzen' || normalizedPath === '/support-project'"
      :support="content.supportProjectPage"
    />
    <TeamPage v-else-if="normalizedPath === '/team'" :team="content.teamPage" />
    <CareerPage v-else-if="normalizedPath === '/karriere'" :career="content.careerPage" />
    <MaintenancePage v-else-if="normalizedPath === '/features'" :page="content.maintenancePages.features" />
    <MaintenancePage v-else-if="normalizedPath === '/dokumentation'" :page="content.maintenancePages.documentation" />
    <JobPage v-else-if="activeJob" :career="content.careerPage" :job="activeJob" />
    <template v-else>
      <HeroSection :hero="content.hero" />
      <ServerSection :servers="content.servers" :showcase="content.serverShowcase" />
      <FeaturePreviewSection :preview="content.featurePreview" />
      <ReviewsSection :reviews="content.reviews" />
      <FaqSection :items="content.faq" :labels="content.faqLabels" />
    </template>
    <SiteFooter v-if="!isLegalPage" :links="content.footerLinks" />
  </div>
</template>

<script>
import BetaTesterPage from './components/BetaTesterPage.vue'
import CareerPage from './components/CareerPage.vue'
import FaqSection from './components/FaqSection.vue'
import FeaturePreviewSection from './components/FeaturePreviewSection.vue'
import HeroSection from './components/HeroSection.vue'
import JobPage from './components/JobPage.vue'
import LegalPage from './components/LegalPage.vue'
import MaintenancePage from './components/MaintenancePage.vue'
import PremiumPage from './components/PremiumPage.vue'
import ReviewsSection from './components/ReviewsSection.vue'
import ServerSection from './components/ServerSection.vue'
import SiteFooter from './components/SiteFooter.vue'
import SiteHeader from './components/SiteHeader.vue'
import SupportProjectPage from './components/SupportProjectPage.vue'
import TeamPage from './components/TeamPage.vue'
import { getHomepageContent, normalizeHomepageLocale } from './services/homepageService'
import { applyTheme, getNextTheme, getSavedTheme, getThemeState, saveTheme } from './services/themeService'

export default {
  name: 'App',
  components: {
    BetaTesterPage,
    CareerPage,
    FaqSection,
    FeaturePreviewSection,
    HeroSection,
    JobPage,
    LegalPage,
    MaintenancePage,
    PremiumPage,
    ReviewsSection,
    ServerSection,
    SiteFooter,
    SiteHeader,
    SupportProjectPage,
    TeamPage
  },
  data() {
    const savedLocale = normalizeHomepageLocale(window.localStorage.getItem('guildguardian-locale'))
    const savedTheme = applyTheme(getSavedTheme())

    return {
      locale: savedLocale,
      content: getHomepageContent(savedLocale),
      activeTheme: savedTheme,
      theme: getThemeState(savedTheme),
      currentPath: window.location.pathname
    }
  },
  computed: {
    normalizedPath() {
      return this.currentPath.toLowerCase()
    },
    activeJob() {
      const slug = this.normalizedPath.startsWith('/karriere/')
        ? this.normalizedPath.replace('/karriere/', '')
        : this.normalizedPath.replace('/', '')

      return this.content.careerPage.openings.find((opening) => opening.slug === slug)
    },
    isLegalPage() {
      return this.normalizedPath === '/imprint' || this.normalizedPath === '/privacy'
    }
  },
  methods: {
    setLanguage(locale) {
      const nextLocale = normalizeHomepageLocale(locale)

      this.locale = nextLocale
      this.content = getHomepageContent(nextLocale)
      window.localStorage.setItem('guildguardian-locale', nextLocale)
    },
    setTheme(theme) {
      const nextTheme = applyTheme(saveTheme(theme || getNextTheme(this.activeTheme)))

      this.activeTheme = nextTheme
      this.theme = getThemeState(nextTheme)
    }
  }
}
</script>
